  <!-- Main section -->
  <section>
    <div class="main_section_headers" id="devicefTagsHeader">
    <img class="fact_tag_header" alt="Device - fact tags display"/>
     <span i18n="@@device-fact-tags.fact-tags-header.facttags">FACT TAGS</span>
    </div>
  
    <!-- Fact tags body -->
    <div class="pl-1 pr-1" id="devicefTagsBodyMain">
      <div class="mt-3" id="devicefTagsChild">
        <span i18n="@@device-fact-tags.fact-tags-header.drag-and-drop">Drag and drop the rows to reorder fact tags and show or hide which fact tags display.</span>
      </div>
      <span class="processor-cant-reorder" i18n="@@fact-tags.fact-tags-header.processor-cant-reorder">”Processor” cannot be reordered.</span>
      <div class="mt-2" *ngIf='!isNonConnectedUser && !selectLength' id="devicefTagsChild1">
        <span i18n="@@device-fact-tags.fact-tags-header.note"><strong>Note:</strong> Fact tags can be updated only in Windows*, Windows* 10 and Linux* IPOS.</span>
      </div>
      <div class="mt-3 mb-3" id="devicefTagsChild2">
        <span class="show-on-bold" i18n="@@device-fact-tags.fact-tags-header.show-on-device" >Show on Device</span>
      </div>
    </div>
  
    <!-- Fact-tag selection -->
    <!-- Processor can not be moved. So keep it static -->
    <div class="ftags_list" *ngFor="let factTag of deviceFactTags; trackBy: trackByFactTags" id="fTagsList">
      <div  class="ftag_selection" *ngIf= "factTag?.values?.name === processor" id="fTagSelection">
        <div class="form-check" [ngbPopover]="popContent" placement="right"  triggers="mouseenter:mouseleave" id="FTagSelectionFrmCheck">
          <input type="checkbox" class="form-check-input" [checked]="factTag?.show" [disabled]="factTag?.required" />
        </div>
        <div class="ftag_name" id="fTagName">{{ factTag?.values?.name }}</div>
        <span>
          <img class="facttag_reorder_processor" alt="reorder ftag" />
          <!-- Removed br for GLS purpose -->
          <ng-template #popContent><span i18n="@@device-fact-tags.fact-tags-header.cant-hidden-reordered">The processor fact tag cannot be hidden or reordered.</span></ng-template>
        </span>
      </div>
    </div>
    <!-- All other fact tags can be moved.
      TODO: Use a pipe below to exclude Processor from the items rendered -->
    <div cdkDropList class="ftags_list"  (cdkDropListDropped)="dropFactTags($event)" *ngIf="deviceFactTags.length" id="fTagsListDiv">
      <div   *ngFor="let factTag of deviceFactTags; trackBy: trackByFactTags; let i=index" cdkDrag id="deviceFtags">
        <div class="ftag_selection" *ngIf="!factTag?.pin && factTag?.name!='vr'" id="fTagSelection">
        <div class="form-check" id="fTagFrmCheck">
          <input type="checkbox" class="form-check-input" [checked]="factTag?.show" [disabled]="factTag?.required"  (change)="checkMemory(i, $event, factTag?.values?.name)"/>
        </div>
        <div class="ftag_name" id="devicefTagName">{{ factTag?.values?.name  }}
          <!-- <div class="ftag_option"  id="devicefTagOption" *ngIf="factTag?.values?.name === memory">
            <div class="option_checkbox" id="devicefTagOptionCheckbox">
              <input type="checkbox" [checked]="factTag?.values.optane_messaging" (change)="checkMemory(i, $event, optaneMemory)"/>
   
            </div>
            <div class="optaneMemory">{{ optaneMemory }}</div>
          </div> -->
        </div>
        <span>
          <img class="facttag_reorder" alt="reorder ftag" />
        </span>
      </div>
      </div>
    </div>
  
  
     <!-- CTA Buttons -->
  <div class="button_wrapper justify-content-end" id="devicefTagBtnWraper">
    <button type="button" class="btn btn-outline-primary btn-lg" (click)='cancel()' [disabled]="!uncheckShowOnDevice" data-dismiss="modal">
      {{cancelLabel}}
    </button>
    <button (click)='sendDataToStore()' [disabled]="!uncheckShowOnDevice" type="button"
      class="btn btn-primary btn-lg gtmEditDeviceSaveDeviceFactTags">
      {{saveChangesLabel}}
    </button>
  </div>
<!-- remove-popup-message -->
<div class="container" id="devicefTagRemovePopup">
  <div class="modal-dialog-centered" *ngIf="openModalPopup" id="devicefTagModal">
    <div class="modal-backdrop show" id="devicefTagModalBackdrop"></div>
    <div class="modal" id="myModal">
      <div class="modal-dialog" id="myModalDeviceDialog">
        <div class="modal-content" id="myModalContent">
          <div _ngcontent-fjy-c198="" class="close" (click)="closeModal()" id="myModalClose"><img _ngcontent-fjy-c198="" alt="close"
              class="modal-close-icon"></div>
          <div class="modal-body" id="myModalBody">
            <div class="text-center" id="myModalTxtCenter">
              <span class="success-img" *ngIf='!isCancel' ></span>
            </div>
            <div class="action-success-msg" [ngClass] = "isCancel ? 'text-left': 'text-center'" id="actionSuccessMsg">
              <span>{{successMessage}}</span>
            </div>
            <div class="card_desc" id="cardDesc">
              <span>{{description}}</span>
            </div>
          </div>
          <div *ngIf='isCancel' class='modal-footer' id="modalFooter">
            <button class='btn btn-outline-primary btn-lg' (click)="closeModal()">{{buttonLabelNo}}</button>
            <button class='btn btn-primary btn-lg' (click)='dismiss()'>{{buttonLabelCancel}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
  </section>
  
